import LegalDocumentPage from "./LegalDocumentPage.jsx";

const TERM_CONTENT = {
  title: "Termos de Uso e Politica de Privacidade",
  date: "Ultima atualizacao: 17 de Abril de 2026",
  sections: [
    {
      heading: "1. Termos de Uso - Tesourinhos",
      subsections: [
        {
          subheading: "1.1. Sobre a plataforma",
          subtext:
            "A Tesourinhos e uma plataforma digital de intermediacao de servicos de cuidado infantil, conectando responsaveis a profissionais qualificadas, que oferecem servico de qualidade visando o bem estar da crianca em primeirissimo lugar. A Tesourinhos e feita para os pais e responsaveis que necessitam confiar seus filhos muito bem cuidados, e em seguranca, para que possam exercer suas atividades ou mesmo ter um lazer de forma tranquila, sabendo que o seu filho esta muito bem amparado. A plataforma nao mantem vinculo empregaticio com as profissionais, atuando exclusivamente como intermediadora, contudo utiliza criterio rigoroso na escolha das babas.",
        },
        {
          subheading: "1.2. Cadastro",
          subtext:
            "Ao utilizar a plataforma, o usuario declara que possui 18 anos ou mais, fornece informacoes verdadeiras, sendo responsavel pelas decisoes de contratacao de forma exclusiva.",
        },
        {
          subheading: "1.3. Funcionamento do servico",
          subtext:
            "A contratacao ocorre por meio de pacotes de assinatura ou avulsos, disponiveis na plataforma. A profissional e indicada conforme disponibilidade e o atendimento ocorre no endereco informado pelo cliente, exclusivamente no tempo contratado pela plataforma.",
        },
        {
          subheading: "1.4. Pagamento",
          subtext:
            "O pagamento e feito diretamente na plataforma. A Tesourinhos retem uma pequena taxa de intermediacao, que varia entre 20% e 30%, para fins de custeio da plataforma, e o restante dos valores obtidos e repassado a profissional.",
        },
        {
          subheading: "1.5. Cancelamento",
          list: [
            "A. Cancelamento pelo cliente (responsavel): Ate 24h antes do servico: Reembolso de 100% ou possibilidade de reagendamento sem custo adicional. Entre 24h e 6h antes: Reembolso de 50% ou credito para uso futuro. Menos de 6h ou nao comparecimento: Sem reembolso, nao ha devolucao do valor pago.",
            "B. Cancelamento pela baby-sitter: Cliente pode: Solicitar substituicao imediata (prioridade alta). Ou receber reembolso integral.",
            "C. Cancelamento pela plataforma Tesourinhos: Reembolso integral ou remarcacao com beneficio.",
            "D. Reagendamento: O reagendamento e permitido ate 12h antes, sem custo adicional. Apos esse prazo considera-se como cancelamento.",
            "E. Pacotes / Assinaturas: As sessoes nao utilizadas podem expirar em 2 dias. Ja o limite de remarcacoes varia conforme assinatura. Entendemos que imprevistos acontecem. Para garantir a organizacao da agenda das nossas profissionais, pedimos atencao aos prazos de cancelamento. Cancelamentos com antecedencia permitem reagendamento sem custo, enquanto cancelamentos de ultima hora podem implicar retencao parcial ou total do valor, devido a reserva exclusiva da profissional.",
          ],
        },
        {
          subheading: "1.6. Responsabilidades",
          list: [
            "A Tesourinhos: Realiza triagem das profissionais. Nao garante compatibilidade pessoal entre as partes.",
            "A selecao das babas e feita de forma criteriosa, e para se tornar parceiro da Tesourinhos, e preciso apresentar o nada consta criminal atualizado, o que minimiza a possibilidade de intercorrencias.",
            "O cliente deve fornecer informacoes claras sobre a crianca, e garantir o ambiente seguro.",
          ],
        },
        {
          subheading: "1.7. Conduta",
          subtext:
            "A conduta das babas e dos contratantes devem ser sempre dotadas de boa-fe. E proibido: Proferir palavras de baixo calao, desrespeito, ofensa, discriminacao, assedio e solicitacao de servicos fora da plataforma. Sujeito a penalidades: suspensao ou exclusao no caso de profissionais, e rescisao unilateral em relacao ao contratante.",
        },
        {
          subheading: "1.8. Foro",
          subtext: "Fica eleito o foro da comarca do Rio de Janeiro/RJ.",
        },
      ],
    },
    {
      heading: "2. Politica de Privacidade - Tesourinhos",
      text: "Em conformidade com a LGPD (Lei 13.709/2018)",
      subsections: [
        {
          subheading: "2.1. Dados coletados",
          subtext:
            "Nome, telefone, e-mail, endereco do atendimento, dados de pagamento, informacoes sobre a crianca como idade, rotina e cuidados.",
        },
        {
          subheading: "2.2. Finalidade",
          subtext:
            "Os dados sao utilizados para: Intermediacao do servico, comunicacao, seguranca das partes e cumprimento de obrigacoes legais.",
        },
        {
          subheading: "2.3. Compartilhamento",
          subtext:
            "Os dados podem ser compartilhados com a profissional cadastrada que prestar servico, plataformas de pagamento e autoridades legais, em caso de medida judicial.",
        },
        {
          subheading: "2.4. Armazenamento",
          subtext:
            "Os dados sao armazenados com seguranca e pelo tempo necessario a prestacao do servico, conforme preve a LGPD (Lei n 13.709/2018) em seu artigo 15.",
        },
        {
          subheading: "2.5. Direitos do usuario",
          subtext:
            "Voce pode acessar seus dados, corrigir informacoes e solicitar exclusao. Solicitacoes: [carla.tesourinhosadm@gmail.com]",
        },
        {
          subheading: "2.6. Seguranca",
          subtext:
            "A Tesourinhos e uma plataforma seria e comprometida com a integridade das partes envolvidas, portanto adota medidas tecnicas para proteger os dados, mas nao garante seguranca absoluta e total contra ataques externos.",
        },
      ],
    },
    {
      heading: "3. Contrato de Prestacao de Servicos - Babá",
      subsections: [
        {
          subheading: "1. Partes",
          subtext:
            "Contratante: Cliente da plataforma Tesourinhos. Contratada: Profissional autonoma cadastrada.",
        },
        {
          subheading: "2. Natureza do vinculo",
          subtext:
            "A profissional atua como prestadora autonoma, sem vinculo empregaticio com a Tesourinhos ou com o cliente. Funciona como uma prestacao de servico de cuidados infantis pactuado entre o responsavel legal da crianca e a baba.",
        },
        {
          subheading: "3. Obrigacoes da profissional",
          subtext:
            "A baba deve cumprir os horarios agendados, alimentar a crianca, interagir com brincadeiras, auxiliar na sua higiene, observar seu comportamento, zelar pela seguranca da crianca, manter postura etica e respeitosa, e informar qualquer ocorrencia relevante aos seus genitores e plataforma, caso necessario.",
        },
        {
          subheading: "4. Obrigacoes do cliente",
          subtext:
            "Deve fornecer instrucoes claras sobre a rotina, a personalidade da crianca, garantir ambiente seguro, tratar as profissionais com respeito e educacao, e efetuar pagamento pela plataforma.",
        },
        {
          subheading: "5. Remuneracao",
          subtext:
            "Sao definidas pelos pacotes da Tesourinhos. O cliente efetua o pagamento para a plataforma e a mesma efetua o repasse em ate 72 horas da conclusao do servico pela baba.",
        },
        {
          subheading: "6. Cancelamento",
          list: [
            "A. Cancelamento pelo cliente (responsavel): Ate 24h antes do servico: Reembolso de 100% ou possibilidade de reagendamento sem custo adicional. Entre 24h e 6h antes: Reembolso de 50% ou credito para uso futuro. Menos de 6h ou nao comparecimento: Sem reembolso, nao ha devolucao do valor pago.",
            "B. Cancelamento pela baby-sitter: Cliente pode: Solicitar substituicao imediata (prioridade alta). Ou receber reembolso integral.",
            "C. Cancelamento pela plataforma Tesourinhos: Reembolso integral ou remarcacao com beneficio.",
          ],
        },
        {
          subheading: "7. Responsabilidade",
          subtext:
            "A profissional responde por sua conduta durante o atendimento. A Tesourinhos nao se responsabiliza por danos decorrentes de condutas individuais e relacoes estabelecidas fora da plataforma.",
        },
        {
          subheading: "8. Confidencialidade",
          subtext:
            "A profissional se compromete a manter sigilo sobre informacoes da familia e rotina da crianca. A Tesourinhos atua com sigilo e discricao total, pensando no bem estar da crianca em primeiro lugar, de clientes e profissionais envolvidas.",
        },
        {
          subheading: "9. Rescisao",
          subtext:
            "O descumprimento das regras pode resultar em exclusao da plataforma e cancelamento imediato dos servicos, conforme a gravidade e analise do caso concreto.",
        },
      ],
      text: "Rio de Janeiro, xx, de xxxxxxxxx de 2026.\n\n____________________________________\nContratante\n\n____________________________________\nContratado",
    },
  ],
};

export default function TermodeUso() {
  return (
    <LegalDocumentPage
      title={TERM_CONTENT.title}
      date={TERM_CONTENT.date}
      sections={TERM_CONTENT.sections}
      accent="slate"
    />
  );
}